import client from "../api/client";
export const getList = () => {
  return client('/api/addresses').then(({ data }) => data.data);
};

export const getDetail = (id) => {
  return client(`/api/addresses/${id}`).then(({ data }) => data.data);
};

export const addEditModel = (values= {}, id=null) => {
  if (id){
    return client(`/api/addresses/${id}`, {method: 'put', body: values}).then(({ data }) => data.data);
  } else {
    return client('/api/addresses', {method: 'post', body: values}).then(({ data }) => data.data);
  }
};

export const delModel = (id) => {
    return client(`/api/addresses/${id}`, {method: 'delete'}).then(({ data }) => data.data);
};

export function useAddressService () {
  return {
    getList,
    addEditModel,
    getDetail,
    delModel,
  };
}
